// src/utils/useTranscurrido.js
//
// Los segundos que lleva una espera. Con consultas que pueden pasar del
// minuto, un contador es la diferencia entre "está trabajando" y "se
// colgó" — y es lo único que se puede decir con certeza, porque ni la OLT
// ni el switch informan de su avance.
//
// Vivía dentro de la pantalla de ONUs; salió aquí cuando la segunda
// pantalla lo necesitó, para no tener dos relojes que se separan.

import { useEffect, useState } from "react";

export function useTranscurrido(activo) {
  const [seg, setSeg] = useState(0);
  useEffect(() => {
    if (!activo) return undefined;
    setSeg(0);
    const t = setInterval(() => setSeg((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, [activo]);
  return seg;
}
